import React from 'react';
import { SearchContentSectionProps } from '../ContentSection';
import { Container, Flex, Group, Image, Stack, Text } from '@mantine/core';
import LoaderLeaderWisdom from '../../../section/LeaderWisdomSection/LoaderLeaderWisdom';
import MultipleLeaderWisdom from '../../../section/LeaderWisdomSection/MultipleLeaderWisdom';
import LeaderWisdomItem from '../../../section/LeaderWisdomSection/LeaderWisdomItem';
import '../../../section/LeaderWisdomSection/styles.scss';
import IllustrationState from '../../IllustrationState';
import NoData from '../../../../assets/icon/illustrations_no-document.svg';
import SearchComponentsWisdom from '../../../section/PersonalWisdom/SearchComponentsWisdom';
import Button from '../../../elements/Button';

const defaultSpacing = '-1rem';
const LeaderWisdomSection: React.FC<SearchContentSectionProps> = ({
  data,
  isSearch,
  querysearch,
  id,
  title,
  subtitle,
  isCarousel,
  loading: loadingState = false,
  isUmum = false,
  isButtonView
}) => {
  const contentList = data.filter((section) => section.id === id)[0]?.contents;
  return (
    <Container size={'xl'} w={'100%'} px={0}>
      {isSearch ? (
        <Stack gap={12}>
          <Group align="center" justify="space-between">
            <Stack gap={0}>
              <Text fz={20} fw={700}>
                {isSearch
                  ? contentList.length > 1
                    ? 'Leader Wisdoms'
                    : 'Leader Wisdom'
                  : title || '-'}
              </Text>
              {isSearch ? (
                <Text fz={14} fw={500} c={'gray'}>
                  {contentList.length} Results
                </Text>
              ) : (
                <Text fz={14} fw={500} c={'gray'}>
                  {subtitle}
                </Text>
              )}
            </Stack>
            {isButtonView == 'Y' && contentList.length > 4 && (
              <Button
                variant="link"
                linkTo={
                  isUmum
                    ? `/s/d?type=002&search=${querysearch}`
                    : `/search/detail?type=002&search=${querysearch}`
                }
              >
                View All
              </Button>
            )}
          </Group>

          {loadingState && <LoaderLeaderWisdom />}

          {!loadingState && contentList.length === 0 && (
            <IllustrationState
              isIlustration={false}
              Illustration={<Image src={NoData} w={'50%'} />}
              description="No result found"
            />
          )}

          <SearchComponentsWisdom
            data={contentList}
            querysearch={querysearch}
          />
        </Stack>
      ) : (
        <Stack gap={12} className="container-leader-wisdom-section">
          <Stack gap={0}>
            <Text
              fz={20}
              fw={700}
              className="container-leader-wisdom-section__title"
            >
              {title}
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {subtitle}
            </Text>
          </Stack>

          <Container
            w={'100%'}
            style={{
              padding: '0px'
            }}
          >
            {loadingState && <LoaderLeaderWisdom />}

            {!loadingState && contentList.length === 0 && (
              <IllustrationState
                Illustration={<Image src={NoData} w={'50%'} />}
                description="No data found"
              />
            )}

            {!loadingState && contentList.length > 1 && (
              <MultipleLeaderWisdom data={contentList} title={title} />
            )}

            {!loadingState &&
              contentList.length === 1 &&
              contentList.map((content, i) => {
                return <LeaderWisdomItem {...content} title={title} key={i} />;
              })}
          </Container>
        </Stack>
      )}
    </Container>
  );
};

export default LeaderWisdomSection;
